import CallPreferencesPage from "./CallPreferencesPage";
export default CallPreferencesPage;
